import React from "react";
import PropTypes from "prop-types";
import { Switch } from "antd";

/**
 * Reusable labeled switch for Ant Design.
 * The label is clickable and visually disabled when the switch is disabled.
 * You can pass any React node as labelContent (e.g., text, tooltip, icon, or a fully custom node).
 */
const LabeledSwitch = ({
  checked,
  disabled,
  onChange,
  label,
  labelContent,
  style,
  ...switchProps
}) => (
  <label
    style={{
      cursor: disabled ? "not-allowed" : "pointer",
      userSelect: "none",
      color: disabled ? "rgba(0,0,0,0.25)" : "inherit",
      display: "flex",
      alignItems: "center",
      ...style,
    }}
  >
    <Switch
      checked={checked}
      disabled={disabled}
      onChange={onChange}
      style={{ verticalAlign: "middle" }}
      tabIndex={-1}
      {...switchProps}
    />
    {(label || labelContent) && (
      <span
        style={{
          marginLeft: label ? 8 : 0,
          verticalAlign: "middle",
          color: disabled ? "rgba(0,0,0,0.25)" : "inherit",
          display: "flex",
          alignItems: "center",
        }}
      >
        {label}
        {labelContent}
      </span>
    )}
  </label>
);

LabeledSwitch.propTypes = {
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  label: PropTypes.node,
  labelContent: PropTypes.node,
  style: PropTypes.object,
};

export default LabeledSwitch;
